<template>
  <div class="A4">
    <img class="header" src="@/assets/images/Serve27@2x.png" alt="">
    <img class="step" src="@/assets/images/Serve28_2@2x.png" alt="">
    <div class="container">
      <div class="p1">郑能量</div>
      <div class="p2">个人观众</div>
      <div class="p3">预登记号:JB23647586595093837</div>
      <div class="p4">
        <QRCode :text="'https://www.cwmuseum.cn/'"></QRCode>
      </div>
      <div class="p5">
        <span>*</span>举重博物馆门票预定成功，入场验证码已经由短信形式发送到您手机，请携带您本人实名登记的有效证据，以便核对。
      </div>
    </div>
  </div>
</template>

<script>
  import QRCode from '@/common/QRCode'
  export default {
    name: "A4",
    components: {
      QRCode
    },
    data() {
      return {

      }
    },
    created(){
      this.toRem()
      window.onresize = () => {
        this.toRem()
      }
    },
    methods: {
      toRem(){
        const htmlDom = document.getElementsByTagName('html')[0];
        let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
        if (htmlWidth >= 750) {
          htmlWidth = 750;
        }
        if (htmlWidth <= 320) {
          htmlWidth = 320;
        }
        htmlDom.style.fontSize = `${htmlWidth / 7.5}px`;
      }
    }
  }
</script>

<style scoped lang="less">
  .A4{
    width: 7.5rem;
    margin: 0 auto;
    padding-bottom: .6rem;
  }
  .header{
    width: 100%;
    height: 1.7rem;
  }
  .step{
    width: 1.7rem;
    height: .5rem;
    margin: .3rem auto .4rem;
    display: block;
  }
  .container{
    background: #FFFFFF;
    box-shadow: 0 .08rem .32rem 0 rgba(65,89,133,0.2);
    border-radius: .15rem;
    width: 6.7rem;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: .7rem;
    padding-bottom: .8rem;
    .p1{
      font-size: .28rem;
      color: #333333;
      padding-bottom: .26rem;
    }
    .p2{
      width: 1.24rem;
      height: .42rem;
      line-height: .42rem;
      background: #EDECEC;
      border-radius: .2rem;
      font-weight: 400;
      font-size: .2rem;
      color: #333333;
      text-align: center;
    }
    .p3{
      padding-top: .38rem;
      padding-bottom: .38rem;
      font-family: SourceHanSans;
      font-weight: bold;
      font-size: .28rem;
      color: #333333;
    }
    .p4{
      width: 2.88rem;
      height: 2.88rem;
    }
    .p5{
      width: 5.2rem;
      margin: .6rem auto 0;
      font-family: Source Han Sans CN;
      font-weight: 400;
      font-size: .28rem;
      color: #777777;
      line-height: .36rem;
      text-align: justify;
      span{
        color: #DA1E2D;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Serve/A4/A4.vue